<template>
  <div class="">
    <b-button v-b-toggle.usersPrivilegeReports class="btn btn-lg btn-collapse">
      {{ $t("reports") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="usersPrivilegeReports">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="treasuriesTransactionsReportView"
              v-model="usersPrivilegeReports.treasuriesTransactionsReportView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="treasuriesTransactionsReportView">{{
              $t("treasuriesTransactions")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="statisticsReportView"
              v-model="usersPrivilegeReports.statisticsReportView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="statisticsReportView">{{
              $t("ReportsMsg.ReservationsStatistics")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeReports",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeReports"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
